import React, { useEffect } from 'react';
import { InvoiceForm } from '../../../Components/Form';
import { FormLayout } from '../../../Components';
import { NewInvoiceIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const EditInvoice = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Invoice.invoice_form.edit_invoice');
  }, []);

  return (
    <FormLayout
      title={t('Invoice.title')}
      Icon={NewInvoiceIcon}
      subtitle={t('Invoice.actions.edit')}
      closeUrl="/invoices"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <InvoiceForm
        title={t('Invoice.invoice_form.edit_invoice')}
        type="edit"
        idFromHeaderWrapper={props.idFromHeaderWrapper}
        handleToast={props.handleToast}
      />
    </FormLayout>
  );
};

export default EditInvoice;
